import React from 'react'
import { useCronSchedule } from '@/hooks/useCronSchedule'
import Typography from '@/components/ui/Typography'
import { formatDate } from '@/utils/string'

export type ScheduleSectionProps = { value: string | undefined }

const ScheduleSection = ({ value }: ScheduleSectionProps) => {
  const [title, intervals] = useCronSchedule(value)

  return (
    <div>
      <Typography variant={'caption'}>{title ?? '-'}</Typography>
      {intervals.map((interval) => (
        <Typography key={interval.toISOString()} variant={'caption'}>
          {formatDate(interval, 'dd.MM.yyyy HH:mm:ss')}
        </Typography>
      ))}
    </div>
  )
}
export default ScheduleSection
